import { BOOKING_SUMMARY_REPORT, BOOKING_SUMMARY_REPORT_SUCCESS, BOOKING_HISTORY_FAIL } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  bookingSummaryReports: [],
};

const bookingSummaryReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case BOOKING_SUMMARY_REPORT: {
      return { ...state, isLoading: true };
    }
    case BOOKING_SUMMARY_REPORT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        bookingSummaryReports: payload,
      };
    }

    case BOOKING_HISTORY_FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default bookingSummaryReportReducer;
